import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import { PromotionScheduleContainer } from '../../containers/promotion/PromotionScheduleContainer';
import { PROMOTION_SCHEDULE_PAGE_NAME } from '../../views/promotion/schedule/constants';

/**
 * 프로모션 스케줄 타임라인 페이지.
 *
 * MD·마케팅팀이 구글시트로 관리하던 연간 프로모션 계획을 대체한다.
 * 간트/캘린더 두 뷰로 같은 데이터를 보여주고, 여기서 만든 스케줄 항목이
 * 이후 기획전·기획안의 부모가 된다.
 */
const PromotionSchedule = (): React.JSX.Element => {
  return (
    <PageTemplate pageName={PROMOTION_SCHEDULE_PAGE_NAME}>
      <PromotionScheduleContainer />
    </PageTemplate>
  );
};

export default PromotionSchedule;
